import eTournamentControllerTypes from '../eTournamentControllerTypes';

export default {
  ETWT_PRIZES: `${eTournamentControllerTypes.ETCT_TABS}__prizes_view`,
  ETWT_NOMINATIONS: `${eTournamentControllerTypes.ETCT_TABS}__nominations_view`,
  ETWT_LEADERBOARD: `${eTournamentControllerTypes.ETCT_TABS}__leaderboard_view`,
  ETWT_RULES: `${eTournamentControllerTypes.ETCT_TABS}__rules_view`,
}
